import { render, staticRenderFns } from "./InstagramV2Channels.vue?vue&type=template&id=5151a4ff&scoped=true"
import script from "./InstagramV2Channels.vue?vue&type=script&lang=js"
export * from "./InstagramV2Channels.vue?vue&type=script&lang=js"
import style0 from "./InstagramV2Channels.vue?vue&type=style&index=0&id=5151a4ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151a4ff",
  null
  
)

export default component.exports